import React from 'react';
import ReactDOM from 'react-dom/client';
import api from './apiClient';
import App from './App';
import './index.css';


// Note: We avoid forcing a navigation to /login here because it can
// interrupt the Firebase OAuth redirect flow (mobile) or race with
// auth initialization. Instead, emit a global event so the Auth
// provider can react (refresh token / logout) in a controlled way.
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      try {
        const ev = new CustomEvent('apiUnauthorized', { detail: { status: 401 } });
        window.dispatchEvent(ev);
      } catch (e) {
        console.warn('Could not dispatch apiUnauthorized event', e);
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);